import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=2f856861&scoped=true"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"
import style0 from "./chat.vue?vue&type=style&index=0&id=2f856861&prod&lang=scss&scoped=true"
import style1 from "./chat.vue?vue&type=style&index=1&id=2f856861&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f856861",
  null
  
)

export default component.exports